<div class="flex">
  <app-jkcombobox
    label="大分類"
    #WD015Com
    id="WD015"
    class="w-56"
    [displayLabel]="false"
    [value]="wd015Str"
    (valueChange)="wd015Change($event)"
    [items]="wd015List"
  >
  </app-jkcombobox>
  <app-crudbar
    [label]="title"
    (onReady)="doComReady($event, 'crudbar')"
    [editAndSaveVisible]="true"
  >
  </app-crudbar>
</div>
<div>
  <!--   <mat-tab-group
    class="jk-tab-group"
    [(selectedIndex)]="wd015Index"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
  >
    @for (item of wd015List; track item.id) {
      <mat-tab
        [label]="item.name"
        [matBadge]="item.ps1"
        [matBadgeDescription]="item.id"
      ></mat-tab>
    }
  </mat-tab-group>
 -->
  <div class="w-full rounded-lg top-10">
    @if (masterVisible) {
      <div class="top-1">
        <app-mtrki01 (onFormReady)="doFormReady($event, PageKind.master)">
        </app-mtrki01>
      </div>
    }
    @if (detailVisible) {
      <div class="top-1">
        <app-mtrki01-detail
          (onFormReady)="doFormReady($event, PageKind.detail)"
        >
        </app-mtrki01-detail>
      </div>
    }
  </div>
  <div></div>
</div>
